import format from "date-fns/format";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../../models/BasketItem";
import useFacility from "../../../../../utils/hooks/useFacility";
import { BasketItem } from "../../../../models/BasketItem";
import { useState } from "react";

export default function useSrem() {
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);

  const addGuideToBasket = async (ids: number, qnt: number) => {
    setLoading(true);
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    await post(ADD_TO_BASKET_URL, {
      ...setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []),
    });
    setLoading(false);
  };

  const addRocket = async (basketList: BasketItem[]) => {
    let bilety: number = 0;
    let rockets: number = 0;
    // eslint-disable-next-line array-callback-return
    basketList.map((item: BasketItem) => {
      if (item.assortIds === "0,405" || item.assortIds === "0,273" || item.assortIds === "0,406") {
        bilety = bilety + item.qnt;
      }
      if (item.assortIds === "0,+407") {
        rockets = rockets + item.qnt;
      }
    });

    setTimeout(() => {
      if(rockets < 1){
        addGuideToBasket(407, 1)
      }
    }, 100);
  };

  const addTenisRocket = async (basketList: BasketItem[]) => {
    let bilety: number = 0;
    let tenisRockets: number = 0;
    // eslint-disable-next-line array-callback-return
    basketList.map((item: BasketItem) => {
      if (item.assortIds === "0,454" || item.assortIds === "0,465") {
        bilety = bilety + item.qnt;
      }
      if (item.assortIds === "0,22") {
        tenisRockets = tenisRockets + item.qnt;
      }
    });

    setTimeout(() => {
      if (bilety !== tenisRockets) {
        addGuideToBasket(22, bilety - tenisRockets);
      }
    }, 100);
  };

  return {
    addTenisRocket,
    addRocket,
    loading,
  };
}
